import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  IconButton,
  Typography,
  DialogContentText,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import "../../../styles/pageStyles/chatbot/inputDialog.css";

const InputDialog = ({
  open,
  title = "Confirm Action",
  placeholder = "Enter value...",
  confirmText = "Submit",
  cancelText = "Cancel",
  value,
  onChange,
  onConfirm,
  onCancel,
  hideInput = false,
  message = "",
  hideActions = false,
  children,
}) => {
  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      if (hideInput || (value && value.trim())) {
        onConfirm && onConfirm();
      }
    }
    if (e.key === "Escape") onCancel();
  };

  return (
    <Dialog
      open={open}
      onClose={onCancel}
      PaperProps={{
        className: "rename-dialog-paper",
      }}
    >
      <DialogTitle className="rename-dialog-title">
        <Typography className="rename-dialog-heading">{title}</Typography>

        <IconButton
          size="small"
          onClick={onCancel}
          className="rename-dialog-close-btn"
        >
          <CloseIcon sx={{ fontSize: 18 }} />
        </IconButton>
      </DialogTitle>

      <DialogContent className="rename-dialog-content">
        {children ? (
          children
        ) : hideInput ? (
          <DialogContentText sx={{fontSize:"14px"}}>{message}</DialogContentText>
        ) : (
          <TextField
            autoFocus
            fullWidth
            value={value}
            onChange={(e) => onChange(e.target.value)}
            onKeyDown={handleKeyDown}
            placeholder={placeholder}
            variant="outlined"
            size="small"
            className="rename-dialog-input"
          />
        )}
      </DialogContent>

      {!hideActions && (
        <DialogActions className="rename-dialog-actions">
          <Button
            onClick={onCancel}
            variant="outlined"
            className="rename-dialog-cancel-btn"
          >
            {cancelText}
          </Button>

          <Button
            onClick={onConfirm}
            variant="contained"
            disabled={!hideInput && (!value || !value.trim())}
            className="rename-dialog-confirm-btn"
          >
            {confirmText}
          </Button>
        </DialogActions>
      )}
    </Dialog>
  );
};

export default InputDialog;
